module.exports = __webpack_public_path__ + "img/su.34d67a64.png";